import { render, staticRenderFns } from "./UserReviewBox.vue?vue&type=template&id=ed21b5c0&"
import script from "./UserReviewBox.js?vue&type=script&lang=js&"
export * from "./UserReviewBox.js?vue&type=script&lang=js&"
import style0 from "./UserReviewBox.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports